import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdjacentType } from '@iotv/datamodel';
import { Stack, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { MultipleObjectAutoComplete, SingleObjectAutoComplete } from '../../generic/ObjectAutoComplete';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ObjectAutoCompleteWidget = (props) => {
    const [singleEntity, setSingleEntity] = useState(undefined);
    const [multipleEntities, setMultipleEntities] = useState([]);
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "SingleObjectAutoComplete" }), _jsx(Stack, { direction: "row", children: props.contextCustomer && (_jsx(SingleObjectAutoComplete, { contextObject: props.contextCustomer, adjacencyType: AdjacentType.CHILD, objectTypeId: 'User', currentEntity: singleEntity, setCurrentEntity: setSingleEntity })) }), _jsx(Typography, { variant: "h5", children: "MultipleObjectAutoComplete" }), _jsx(Stack, { direction: "row", children: props.contextCustomer && (_jsx(MultipleObjectAutoComplete, { contextObject: props.contextCustomer, adjacencyType: AdjacentType.CHILD, objectTypeId: 'User', currentEntities: multipleEntities, setCurrentEntities: setMultipleEntities })) })] })), [props.contextCustomer, singleEntity, multipleEntities]);
    return {
        name: 'ObjectAutoComplete',
        category: 'generic',
        component,
    };
};
